var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OrderList"},[_c('navigator',{attrs:{"title":"订单中心"}}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('van-cell',{key:index,attrs:{"title":item.serviceName,"is-link":"","to":'/personal/orderList?serviceFlag='+item.serviceFlag}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00f834f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal/Property.vue
// module id = null
// module chunks = 